import { render, staticRenderFns } from "./CUSkeletonLoader.vue?vue&type=template&id=24a654e4&scoped=true"
import script from "./CUSkeletonLoader.vue?vue&type=script&lang=ts"
export * from "./CUSkeletonLoader.vue?vue&type=script&lang=ts"
import style0 from "./CUSkeletonLoader.vue?vue&type=style&index=0&id=24a654e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a654e4",
  null
  
)

export default component.exports